import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralLighterAlt,
    margin: `0 ${pxToRem(24)} ${pxToRem(24)} ${pxToRem(24)}`,
  },
});
